import type {
  WidgetElementsBookingElementButtonStyles,
  WidgetElementsBookingElementButtonStylesDto,
} from "@/elements/widget/elements/booking-element/button/styles/widget-elements-booking-element-button-styles";

export enum WidgetElementsBookingElementButtonPositionAlignment {
  Start = "start",
  End = "end",
}

export enum WidgetElementsBookingElementButtonAnimationType {
  None = "none",
  Bounce = "bounce",
  Pulse = "pulse",
}

export interface WidgetElementsBookingElementButton {
  position: WidgetElementsBookingElementButtonPosition;
  animation: WidgetElementsBookingElementButtonAnimation;
  styles: WidgetElementsBookingElementButtonStyles;
  shouldAutoInject: boolean;
}

export interface WidgetElementsBookingElementButtonPosition {
  x: WidgetElementsBookingElementButtonPositionAlignment;
  y: WidgetElementsBookingElementButtonPositionAlignment;
}

export interface WidgetElementsBookingElementButtonAnimation {
  type: WidgetElementsBookingElementButtonAnimationType;
}

export interface WidgetElementsBookingElementButtonDto {
  position: WidgetElementsBookingElementButtonPosition;
  animation: WidgetElementsBookingElementButtonAnimation;
  styles: WidgetElementsBookingElementButtonStylesDto;
  shouldAutoInject: boolean;
}
